export default __webpack_public_path__ + "static/media/0.894e1dbb.gif";